import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  input,
  model,
  output,
} from "@angular/core";
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from "@angular/forms";
import { MessageService } from "primeng/api";
import { AllegatiService } from "src/app/core/allegati.service";
import {
  AllegatiCondivisiRequest,
  DocumentoAllegato,
} from "src/app/shared/models/documentoAllegato.model";

@Component({
  selector: "app-add-allegati-condivisi-dialog",
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: ` 
  <p-dialog header="Aggiungi allegato condiviso" [(visible)]="visible" [modal]="true" (onHide)="hide.emit($event)" [style]="{'width':'30%'}">
  <div class="grid flex-column gap-4 p-3">
    <div class="flex justify-content-between w-full">
      <div>
      Per procedere al caricamento del file <strong>{{selectedAllegato()?.fileName}}</strong> ({{selectedAllegato()?.length ?? 0 | fileSize}}) dall'area condivisa si prega di inserire il nome del documento
      </div>
      <!-- <div>
        <div id="nome" class="allegato-info">
          {{selectedAllegato()?.fileName}}
        </div>
        <label for="nome" class="small-label">Documento da importare</label>
      </div>
      <div>
        <div id="dimensione" class="allegato-info">
          {{selectedAllegato()?.length}} bytes
        </div>
        <label for="dimensione" class="small-label">Dimensione</label>
      </div> -->
    </div>
    <div class="w-full">
      <form [formGroup]="uploadAllegatoForm" (ngSubmit)="aggiungiAllegatCondiviso()">
        <label for="nameInput" class="small-label text-black-alpha-90">Nome documento</label>
        <div class="flex align-items-end">
          <input pInputText id="nameInput" type="text" class="w-full" placeholder="Inserisci nuovo nome" formControlName="fileName" [pKeyFilter]='invalidFileNameChars'/>
          <p class="extension pl-2">{{getFileExtension()}}</p>
        </div>
      </form>
    </div>
    <p-fieldset legend="Note di compilazione" class="w-100">
      <ul class="pl-3">
        <li>il nome del documento non può contenere i caratteri <strong>< > : " / \\ | ? *</strong></li>
        <li>il nome del documento deve essere diverso da quelli già inseriti</li>
      </ul>
    </p-fieldset>
    <div class="allegato-info">
      Al completamento dell'operazione il file selezionato verrà eliminato dall'area condivisa.
    </div>
  </div>
  <p-footer>
    <button pButton type="button" icon="pi pi-times" label="Annulla" (click)="hideDialog()"
      class="p-button-secondary"></button>
    <button pButton type="button" icon="pi pi-check" label="Salva"
      [disabled]="uploadAllegatoForm.invalid"
      (click)="aggiungiAllegatCondiviso()">
    </button>  
  </p-footer>
  <p-dialog>`,
  styles: [
    `
      .textError {
        color: red;
        width: 100%;
      }
      .extension {
        color: gray;
      }
      .allegato-info {
        font-weight: 700
      }
    `,
  ],
})
export class AddAllegatiCondivisiDialogComponent {
  visible = model<boolean>(false);
  allegati = input<string[]>([]);
  selectedAllegato = input<DocumentoAllegato>();
  hide = output();
  allegatoToUpload = output<AllegatiCondivisiRequest>();

  public newName = '';

  private readonly allegatiService = inject(AllegatiService);
  private readonly fb = inject(FormBuilder);
  private readonly messageService = inject(MessageService);
  public invalidFileNameChars = /[^\\/:*?"<>|]/;

  public uploadAllegatoForm = this.fb.group({
    fileName: new FormControl(null, [Validators.required])}, 
    { validators: this.validateForm.bind(this) }
  );

  public errorMessage: string | undefined;

  constructor() {
    effect(() => {
      if(this.visible()){
        this.uploadAllegatoForm.reset();
      }
    })
  }

  aggiungiAllegatCondiviso() {
    if (this.uploadAllegatoForm.valid && this.uploadAllegatoForm.value.fileName) {
      const allegatoRequest = {
        currentFileName: this.selectedAllegato()?.fileName,
        newFileName: this.uploadAllegatoForm.value.fileName,
      } as AllegatiCondivisiRequest;
      this.allegatoToUpload.emit(allegatoRequest);
      this.hide.emit();
    }
  }

  allegatoPreview(name: string) {
    this.allegatiService.getAllegatoPreview(name);
  }

  hideDialog(): void {
    this.hide.emit();
  }

  public getFileExtension(): string {
    return this.selectedAllegato()?.fileName.slice(this.selectedAllegato()?.fileName.lastIndexOf(".")) ?? '';
  }

  private validateForm(control: AbstractControl): ValidationErrors | null {
    const form = control as FormGroup;
    
    const nomeFile = form.get('fileName')?.value + this.getFileExtension();

    return nomeFile 
      && !this.allegati().includes(nomeFile) ? null : { nuovoPassaggioConsegneNotValid: true };
  }
}
